export default class Tabs {
  constructor() {
    if (!this.setVars()) return;
  
    this.resizeTimer = null;
    this.setEvents();
    this.tabControl();
  }
  
  setVars() {
    this.tabs = jQuery('.tabbed-content').find('.tabs');
    
    if (!this.tabs) return;
    
    return true;
  }
  
  setEvents() {
    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimer);
      
      this.resizeTimer = setTimeout(() => {
        this.tabControl();
      }, 250);
    })
  }
  
  tabControl() {
    if (this.tabs.is(':visible')) {
      this.tabs.find('a').on('click', function (event) {
        event.preventDefault();
        const target = jQuery(this).attr('href'),
          tabs = jQuery(this).parents('.tabs'),
          buttons = tabs.find('a'),
          item = tabs.parents('.tabbed-content').find('.tabs__item');
        buttons.removeClass('active');
        item.removeClass('active');
        jQuery(this).addClass('active');
        jQuery(target).addClass('active');
      });
    } else {
      jQuery('.tabs__item').on('click', function () {
        const container = jQuery(this).parents('.tabbed-content'),
          currId = jQuery(this).attr('id'),
          items = container.find('.tabs__item');
        container.find('.tabs a').removeClass('active');
        items.removeClass('active');
        jQuery(this).addClass('active');
        container.find('.tabs a[hrefjQuery="#' + currId + '"]').addClass('active');
      });
    }
  }
}
